import React from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@carnica/ui-kit';
import { useAnimationEnd } from "./utils";
import styles from "./styles.pcss";
import { connector } from "./connector";
var cx = classNames.bind(styles);
var _SuccessForm = function _SuccessForm(_ref) {
  var resetForm = _ref.resetForm,
    confirmationEmail = _ref.confirmationEmail,
    retryEmail = _ref.retryEmail;
  var _useAnimationEnd = useAnimationEnd(resetForm),
    isVisible = _useAnimationEnd.isVisible,
    isExiting = _useAnimationEnd.isExiting,
    handleStartExit = _useAnimationEnd.handleStartExit,
    elementRef = _useAnimationEnd.elementRef;
  if (!isVisible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrap', {
      'wrap__fade-out': isExiting
    }),
    ref: elementRef,
    "data-t-id": "SubscriptionForms-SuccessForm"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('wrap__text')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx('animate-text'),
    color: "secondary",
    size: "xs"
  }, confirmationEmail)), /*#__PURE__*/React.createElement(Button, {
    className: cx('animate-button'),
    onClick: handleStartExit,
    size: "m",
    view: "secondary"
  }, retryEmail));
};
export var SuccessForm = connector(_SuccessForm);